import ForgotPassword2PageConfig from './auth/forgot-password-2/ForgotPassword2PageConfig';
import ForgotPasswordPageConfig from './auth/forgot-password/ForgotPasswordPageConfig';
import LockPageConfig from './auth/lock/LockPageConfig';
import Login2PageConfig from './auth/login-2/Login2PageConfig';
import LoginPageConfig from './auth/login/LoginPageConfig';
import MailConfirmPageConfig from './auth/mail-confirm/MailConfirmPageConfig';
import Register2PageConfig from './auth/register-2/Register2PageConfig';
import RegisterPageConfig from './auth/register/RegisterPageConfig';
import ResetPassword2PageConfig from './auth/reset-password-2/ResetPassword2PageConfig';
import ResetPasswordPageConfig from './auth/reset-password/ResetPasswordPageConfig';
import Error404PageConfig from './errors/404/Error404PageConfig';
import Error500PageConfig from './errors/500/Error500PageConfig';
import OwnerRegisterConfig from '../ownerRegister/OwnerRegisterConfig';
import DpLinkPageConfig from './dplink/DplinkPageConfig';
import ProfilePageConfig from './profile/ProfilePageConfig';
import SupportPageConfig from './support/SupportPageConfig'

const pagesConfigs = [
	LoginPageConfig,
	RegisterPageConfig,
	ResetPasswordPageConfig,
	ForgotPasswordPageConfig,
	MailConfirmPageConfig,
	LockPageConfig,
	Login2PageConfig,
	Register2PageConfig,
	ForgotPassword2PageConfig,
	ResetPassword2PageConfig,
	Error404PageConfig,
	Error500PageConfig,
	OwnerRegisterConfig,
	DpLinkPageConfig,
	ProfilePageConfig,
	SupportPageConfig
];

export default pagesConfigs;
